import { Injectable, WritableSignal, effect, signal } from '@angular/core';
import { BusinessProcessTaskDataInterface } from 'app/api';
import { Field } from 'app/data-api';
import { TaskProcessService } from 'app/modules/task/task-process.service';
import { OrgNavigationService } from 'app/services/org-nav.service';

@Injectable()
export class AifDialogService {
    private _fieldsInItem: WritableSignal<Array<Field>> = signal([]);

    public get fieldsInItem() {
        return this._fieldsInItem();
    }

    private _items: WritableSignal<BusinessProcessTaskDataInterface[]> = signal([]);

    public get items() {
        return this._items();
    }

    categoriesWithFields = [3, 4, 7, 8, 13];

    private _io: WritableSignal<'input' | 'output'> = signal('input');
    public get io() {
        return this._io();
    }
    private _item: WritableSignal<BusinessProcessTaskDataInterface> = signal(null);
    public get item() {
        return this._item();
    }

    constructor(
        private orgNav: OrgNavigationService,
        private service: TaskProcessService
    ) {
        effect(() => {
            if (this._io() && !this._item()) {
                this.setItemsByIO();
            } else if (this._io() && this._item()) {
                this._fieldsInItem.set([]);
                this.setFieldsByItem();
            }
        });
    }

    private setItemsByIO(): void {
        const taskId = this.getTaskId();

        const task = this.service.model().tasks.find(task => task.id === taskId);

        const items = task.data[this._io()].filter(item =>
            this.categoriesWithFields.includes(item.category)
        );

        this._items.set(items);
    }

    private setFieldsByItem(): void {
        const inputFields = this._item().fields;

        this._fieldsInItem.set(inputFields);
    }

    private getTaskId(): string {
        const url = this.orgNav.url;

        return url.split('/').pop();
    }

    getFields(): Array<Field> {
        return this._fieldsInItem();
    }

    setIO(io: 'input' | 'output'): void {
        this._io.set(io);
    }
    setItem(item: BusinessProcessTaskDataInterface): void {
        this._item.set(item);
    }
}
